module.exports = __webpack_public_path__ + "img/james_grimsted.4adef0e0.png";